function t(r) {
  return r.isVector3 === !0;
}
export {
  t as isVector3
};
//# sourceMappingURL=index15.js.map
